import { useEffect } from "react";
import { SITE, PHONE, COMPANY, CITIES, NRW_CITIES, FAQS } from "@/lib/siteConfig";

// Injects JSON-LD structured data into <head>
export const SeoHead = () => {
  useEffect(() => {
    const localBusiness = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${SITE.url}/#business`,
      name: COMPANY.name,
      legalName: COMPANY.name,
      founder: { "@type": "Person", name: COMPANY.owner },
      description:
        "Security Staging in NRW und deutschlandweit: Professionelle Funk-Alarmanlagen für leerstehende Immobilien – Schwerpunkt Nordrhein-Westfalen (Dortmund, Köln, Düsseldorf, Essen, Duisburg, Bochum, Ruhrgebiet). Schutz vor Einbruch, Wasser und Feuer sowie starkes Verkaufsargument.",
      url: SITE.url,
      telephone: PHONE.display,
      email: COMPANY.email,
      vatID: COMPANY.vatId,
      areaServed: [
        { "@type": "State", name: "Nordrhein-Westfalen" },
        { "@type": "Country", name: "Deutschland" },
      ],
      serviceArea: CITIES.map((c) => ({ "@type": "City", name: c })),
      address: {
        "@type": "PostalAddress",
        streetAddress: COMPANY.street,
        postalCode: COMPANY.postalCode,
        addressLocality: COMPANY.city,
        addressRegion: "Nordrhein-Westfalen",
        addressCountry: COMPANY.country,
      },
      priceRange: "€€",
      image:
        "https://images.unsplash.com/photo-1615816646372-cb8673878757?w=1600&q=85",
    };

    const service = {
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Security Staging – Alarmanlagen-Staging für Immobilien",
      provider: { "@id": `${SITE.url}/#business` },
      areaServed: [
        { "@type": "State", name: "Nordrhein-Westfalen" },
        ...NRW_CITIES.map((c) => ({ "@type": "City", name: c })),
        { "@type": "Country", name: "Deutschland" },
      ],
      description:
        "Installation professioneller Funk-Alarmanlagen in leerstehenden Immobilien während der Vermarktungsphase. Spurlos, schnell und deutschlandweit verfügbar – Schwerpunkt Nordrhein-Westfalen.",
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        priceCurrency: "EUR",
      },
    };

    const faqPage = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };

    const scripts = [];
    const inject = (data, id) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = id;
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      scripts.push(s);
    };

    inject(localBusiness, "ld-localbusiness");
    inject(service, "ld-service");
    inject(faqPage, "ld-faqpage");

    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return null;
};
